import React , {useMemo, useState , useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import { addCommasOnNumber, fieldSizing } from '../../utils/utilities';
import "./textfieldcustom.css";
import FieldInfo from '../FieldInfo/FieldInfo';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import { FIELDTYPE } from "../../constants/field-type";
import { namedQuery } from 'firebase/firestore';

const TextFieldCustom = ({
    label,
    name,
    variant,
    fullWidth = true,
    multiline,
    required,
    value,
    setValue,
    size,
    type = "",
    withInfo = false,
    description,
    error,
    errorMsg="This is a required field",
    disabled=false,
    withFormula,
    placeholder
}) => {
    const id = multiline ? 'outlined-multiline-flexible' : 'standard-helperText';
    //set the default value from Props
    const [textVal , setTextVal] = useState(value);

    useEffect( () => {
        setTextVal(value)
    },[value])

    const onTextChange = (e) => {
        // setState within the components only; to avoid rerendering of parent components
        const val = e.target.value;
        const rawVal = val.replace(/,/g, '');

        if (type === FIELDTYPE.NUMBER ||
            type === FIELDTYPE.CURRENCY
        ) {
            if (!/^\d*\.?\d{0,2}$/.test(rawVal)) { return e.preventDefault() }
            setTextVal(rawVal)
        }
        else {
            setTextVal(val)
        }
    }
    
    const onBlurText = (e) => {
        //will set to the global State
        const value = e.target.value;

        if (setValue) {
            if(type === FIELDTYPE.CURRENCY){
                if(value){
                    setTextVal(addCommasOnNumber(value))
                    setValue(addCommasOnNumber(value))
                }else{
                    setValue("0")
                    setTextVal("0")
                }
       
            }
            else{
                setValue(value);
            }
        }


     
    }

    const fieldSize = useMemo( () => 
        fieldSizing(size)
    ,[size])


    return (
        <Grid xs={fieldSize.xs} sm={fieldSize.sm} md={fieldSize.md} lg={fieldSize.lg} >
            <TextField
                // id={id}
                id={label}
                name={name}
                label={label}
                variant={variant ? variant : 'outlined'}
                fullWidth={fullWidth ? fullWidth : false}
                multiline={multiline ? multiline : false}
                required={required ? required : false}
                placeholder={placeholder}
                value={ withFormula ? 
                    (value ? addCommasOnNumber(parseFloat(value.replace(/,/g, '')).toFixed(2)) : "") : 
                    textVal ? textVal : ''
                } //if the field is with formula, display the actual state value , else the component state only (textVal)
                onChange={(event) => { onTextChange(event) }}
                onBlur = { (event) => {onBlurText(event)}}
                // type={type}
                maxRows={8}
                minRows={multiline ? 2 : 1}
                error={error}
                disabled={disabled}
                InputProps={{
                    endAdornment: (
                        withInfo &&
                        <InputAdornment position="end">
                            <FieldInfo content={description} />
                        </InputAdornment>
                    ),
                    startAdornment: (
                        type === FIELDTYPE.CURRENCY &&
                        <InputAdornment position="start">$</InputAdornment>
                    )
                }}
            />
            <FormHelperText error> {error && errorMsg} </FormHelperText>
        </Grid>


    )
}

export default TextFieldCustom;